import GenericDialog from "../../../../../../../ui/dialogs/generic-dialog/GenericDialog";
import Typography from "@material-ui/core/Typography";
import {Button} from "@material-ui/core";
import IconLeft from "@material-ui/icons/ChevronLeft";
import CardsWithImages
    from "../../../../../contratto-digitale/digital-contract-details/tabs/offerte/offerte-piano-opzione-table/details-dialog/cards-with-images/CardsWithImages";
import DettaglioPianoCard
    from "../../../../../contratto-digitale/digital-contract-details/tabs/offerte/offerte-piano-opzione-table/details-dialog/dettaglio-piano-card/DettaglioPianoCard";
import PacchettiAggiuntivi from "./pacchetti-aggiuntivi-table/PacchettiAggiuntivi";
import PropTypes from "prop-types";

const OfferteDetailsDialog = (props) => {
    const dialogContent = (
        <>
            <Button variant={"text"}
                    onClick={props.handleDialogClose}
                    color={"primary"}
                    startIcon={<IconLeft/>}>Indietro</Button>
            <CardsWithImages planCardsData={props.planCardsData}/>
            <DettaglioPianoCard arePianoDetails={true}
                                isFromConsip
                                planName={props.planCardsData.itemName}/>
            <PacchettiAggiuntivi />

        </>
    )

    return (
        <GenericDialog
            open={props.open}
            dialogContent={dialogContent}
            dialogWidth={"lg"}
            handleDialogClose={props.handleDialogClose}
            handleDialogCloseButton={props.handleDialogClose}>
            <Typography variant={"h5"}>{props.planCardsData.itemName}</Typography>
        </GenericDialog>
    );
}

OfferteDetailsDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleDialogClose: PropTypes.func.isRequired,
    planCardsData: PropTypes.shape({
        itemName: PropTypes.string.isRequired,
        activationPriceDisplayValue: PropTypes.string.isRequired,
        monthlyPriceDisplayValue: PropTypes.string.isRequired,
        numberOfSimsDisplayValue: PropTypes.string.isRequired,
        tipologia: PropTypes.string.isRequired,
    }).isRequired,
}

export default OfferteDetailsDialog;